const airoute = [
    //借款申请第二版

    {
      path: '/ai/chat',
      component: () => import('@/pages/ai/chat.vue'),
      meta: {
        title: '',
        keepAlive: false
      }
    },



  ]
export default airoute



// WEBPACK FOOTER //
// ./src/router/modules/ai.js